export const DEFAULT_BLUR_WIDTH_IN_PX = 100;
export const LOAD_BUFFER_SIZE = 3;
export const DATA_INDEX_ATTRIBUTE = 'data-index';
